import useLidarTelemetryLiveBridge from "../../hooks/useLidarTelemetryLiveBridge";

const LidarTelemetryLiveBridge = () => {
  useLidarTelemetryLiveBridge();
  return null;
};

export default LidarTelemetryLiveBridge;
